import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import useCancellationToken from 'utils/customHook/useCancellationToken';
import StatusModuleList from './statusModule/StatusModuleList';
import { StatusInfoContainer } from './StatusComponentInfo.css.js';
import { nvl } from 'utils/nvl';

const checkTotalStatus = (log) => {
  return nvl(log[0], { status: 'blue' }).status;
};

const statusOrderMap = ['blue', 'none', 'warning', 'danger'];

const StatusComponentInfo = (props) => {
  const cancellationToken = useCancellationToken();
  const [infoData, setInfoData] = useState(null);

  const gasLog = useSelector((store) => store.gasLog);

  useEffect(() => {
    if (cancellationToken.isCancelled) {
      return;
    }

    if (gasLog.status !== 'SUCCESS') {
      return;
    }

    const list = props.moduleGroups.map((x) => {
      const groupIdx = x.moduleGroupIdx;
      const modulesInGroup = gasLog.gas.filter((y) => y.moduleGroupIdx === groupIdx);

      return { title: x.modelNm, log: modulesInGroup, totalStatus: checkTotalStatus(modulesInGroup) };
    });

    setInfoData(() => {
      return list;
    });
  }, [gasLog]);

  useEffect(() => () => cancellationToken.cancel(), []);

  if (!infoData) {
    return null;
  }

  return (
    <StatusInfoContainer typeLength={['gas'].length}>
      {infoData.map((data) => {
        return <StatusModuleList key={data.title} {...data} />;
      })}
    </StatusInfoContainer>
  );
};

export default React.memo(StatusComponentInfo);
